<div>
  <a [ngClass]="data.mainType" class="btn mr-2">
    <i [ngClass]="data.mainIcon" class="mr-2"></i>
    {{ data.mainTitle }}
  </a>
  <a class="btn btn-link">{{ data.additionalTitle }}</a>
</div>